import { FormFieldData } from "modules/forms";
import { OpportunityEntity } from "shared/types/domain/OpportunityEntity";
import { IMapper } from "shared/types/IMapper";
import { CreateOpportunityRequest } from "../mutations/create-opportunity.mutations.types";
import { ObservationrecordOriginEnum } from "shared/enums/ObservationrecordOrigin.enum";
import i18next from 'i18next';
import { ObservationLanguageEnum } from "shared/enums/ObservationLanguageEnum";

export class CreateOpportunityRequestMapper implements IMapper<FormFieldData<OpportunityEntity>, CreateOpportunityRequest> {
    map(entity: FormFieldData<OpportunityEntity>): CreateOpportunityRequest {
        return {
            depotPcId: entity.depotPcId,
            whatHappened: entity.whatHappened,
            whoShouldBeCommended: entity.whoShouldBeCommended,
            reporterType: entity.reporterType.toUpperCase(),
            anonymousEntry: entity.anonymousEntry ?? false,
            contactName: entity.reporterContactName,
            contactPhoneNumber: entity.reporterPhoneNumber,
            contactEmail: entity.reporterEmail,
            createdFrom: ObservationrecordOriginEnum.WebApp,
            selectedLanguage: ObservationLanguageEnum[i18next.language.toUpperCase() as keyof typeof ObservationLanguageEnum],
            enhancements: {
                processId: entity.processId,
                reachId: entity.reachId
            }
        }
    };
}